module.exports = __webpack_public_path__ + "img/audio_on.301113ca.png";